export const blockIconsHomeVerticalShadesClosed = (
	<span className='material-symbols-outlined'>vertical_shades_closed</span>
);
